import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://www.linkedin.com/in/balendra-singh-parihar-b9588a234/'
      className='link footer__link'
    >
      Created By Balendra Singh Parihar
    </a>
  </footer>
)

export default Footer
